export default "__VITE_ASSET__63nGS0KX__"